"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type StatsProps = Extract<CampaignPageSection, {
  type: "stats";
}>;

/** Baris angka pencapaian: nilai besar warna brand + label kecil. */
export default function StatsSection(t0) {
  const $ = _c(16);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style || $[3] !== section.heading) {
    t2 = section.heading && <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</h2>;
    $[2] = section.custom_style;
    $[3] = section.heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${section.heading ? "mt-10" : ""} grid grid-cols-2 gap-x-6 gap-y-10 text-center ${section.items.length <= 3 ? "sm:grid-cols-3" : "sm:grid-cols-4 lg:grid-cols-4"}`;
  let t4;
  if ($[5] !== section.items) {
    t4 = section.items.map(_temp);
    $[5] = section.items;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="mx-auto max-w-6xl px-5">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = <section className="bg-white py-14 md:py-20" style={t1}>{t6}</section>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(item, i) {
  return <div key={i}><p className="text-4xl font-extrabold tracking-tight text-[var(--brand-primary)] md:text-5xl">{item.value}</p><p className="mt-2 text-sm font-medium text-gray-600">{item.label}</p></div>;
}